import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IFirmwareContext, FirmwareContext } from '../../../../firmwareState/firmwareContext';
import Item from './components/Item';
import classNames from 'classnames';
import style from './List.module.scss';

const List: React.FC = () => {
	const { firmware } = useContext<IFirmwareContext>(FirmwareContext);

	const nameHeadingClasses = classNames(style.name, style.heading);
	const versionHeadingClasses = classNames(style.version, style.heading);
	const descriptionHeadingClasses = classNames(style.description, style.heading);
	const firmwareTypeHeadingClasses = classNames(style.firmwareType, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div className={style.container} data-test="List">
			<div className={style.tableHeaders}>
				<Text
					className={nameHeadingClasses}
					translationNameSpace="listing"
					translationKey="nameLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={versionHeadingClasses}
					translationNameSpace="listing"
					translationKey="versionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={descriptionHeadingClasses}
					translationNameSpace="listing"
					translationKey="descriptionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={firmwareTypeHeadingClasses}
					translationNameSpace="listing"
					translationKey="firmwareTypeLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={actionHeadingClasses}
					translationNameSpace="listing"
					translationKey="actionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{firmware.items.map((item, index) => (
				<Item data={item} key={item.id} index={index} />
			))}
		</div>
	);
};

export default List;
